export default __webpack_public_path__ + "static/media/mobile.776d9486.png";